<template>
  <div>
    <!-- Modal de Registro / Edición de Pre-Programación -->
    <v-dialog v-model="showEdit" max-width="950px" persistent v-if="showEdit" transition="dialog-bottom-transition">
      <v-card class="rounded-lg overflow-hidden elevation-12">
        <!-- Header Banner -->
        <div class="modal-header d-flex align-center justify-space-between px-4 py-3 bg-primary text-white">
          <div class="d-flex align-center">
            <v-avatar color="white" size="36" class="mr-3 elevation-1">
              <v-icon color="primary" small>mdi-calendar-edit</v-icon>
            </v-avatar>
            <div>
              <h3 class="white--text subtitle-1 font-weight-bold mb-0 lh-1">
                {{ item && item.HpsID ? 'Editar Pre-Programación #' + item.HpsID : 'Nueva Pre-Programación de Cosecha' }}
              </h3>
              <span class="white--text caption opacity-80">
                Paso previo para el registro de estimaciones y solicitudes preliminares en campo
              </span>
            </div>
          </div>
          <v-btn icon dark small @click="showEdit = false" class="opacity-80">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </div>

        <v-card-text class="pa-4 bg-light">
          <HarvestPreScheduleEdit ref="edit" :objEdit="item" @close="closeEdit()" />
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions class="px-4 py-3 bg-white d-flex justify-space-between">
          <v-btn small text color="grey darken-1" class="text-none" @click="showEdit = false">Cancelar</v-btn>
          <v-btn
            small
            color="primary"
            elevation="2"
            class="px-4 text-none font-weight-bold rounded-pill"
            @click="$refs.edit.save()"
          >
            <v-icon left small>mdi-content-save-check</v-icon>
            Guardar Pre-Programación
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modal Armado / Consolidación de Programación de Cosecha -->
    <v-dialog v-model="showArmarSchedule" max-width="1200px" persistent v-if="showArmarSchedule" transition="dialog-bottom-transition">
      <v-card class="rounded-lg overflow-hidden elevation-12">
        <!-- Header Banner -->
        <div class="modal-header d-flex align-center justify-space-between px-4 py-3 bg-primary text-white">
          <div class="d-flex align-center">
            <v-avatar color="white" size="36" class="mr-3 elevation-1">
              <v-icon color="primary" small>mdi-layers-plus</v-icon>
            </v-avatar>
            <div>
              <h3 class="white--text subtitle-1 font-weight-bold mb-0 lh-1">
                Armar Programación de Cosecha (Consolidación)
              </h3>
              <span class="white--text caption opacity-80">
                Vista previa del armado agrupando {{ selectedPreCheck.length }} pre-programaciones seleccionadas
              </span>
            </div>
          </div>
          <v-btn icon dark small @click="showArmarSchedule = false" class="opacity-80">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </div>

        <v-card-text class="pa-4 bg-light">
          <HarvestScheduleEdit ref="armarEdit" :objEdit="itemArmar" @close="closeArmarSchedule()" />
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions class="px-4 py-3 bg-white d-flex justify-space-between">
          <v-btn small text color="grey darken-1" class="text-none" @click="showArmarSchedule = false">Cancelar</v-btn>
          <v-btn
            small
            color="primary"
            elevation="2"
            class="px-4 text-none font-weight-bold rounded-pill"
            @click="$refs.armarEdit.save()"
          >
            <v-icon left small>mdi-content-save-check</v-icon>
            Guardar Programación Definitiva
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-container fluid>
      <v-row>
        <v-col cols="12" class="pt-2 pb-1">
          <s-crud
            @add="(item = null), (showEdit = true)"
            edit
            add-no-function
            add
            excel
            height="auto"
            searchInput
            ref="crud"
            @getFullData="getData($event)"
            @edit="editItem($event)"
            title="Pre-Programación de Cosecha"
            :config="config"
            :filter="filter"
            :show-group-by="true"
            :group-by="'FltID'"
            sortable
            :single-row="false"
            @rowSelected="rowSelected($event)"
          >
            <!-- Slot Opciones de Toolbar -->
            <template v-slot:options>
              <v-tooltip bottom="" v-if="selectedPreCheck.length > 0">
								<template v-slot:activator="{ on }">
									<v-btn v-on="on" text black @click="openArmarHarvestSchedule()" small>
										<i class="fas fa-layer-group"></i>
									</v-btn>
								</template>
								<span>Crear</span>
							</v-tooltip>
            </template>

            <!-- Slot Filtros -->
            <template v-slot:filter>
              <v-container class="pa-0 pb-3" dense fluid>
                <v-row justify="center" dense class="s-col-form">
                  <v-col lg="3" cols="12">
                    <s-date label="Fecha Inicio" v-model="filter.HpsBeginDate"></s-date>
                  </v-col>
                  <v-col lg="3" cols="12">
                    <s-date label="Fecha Fin" v-model="filter.HpsEndDate"></s-date>
                  </v-col>
                  <v-col lg="3" cols="12">
                    <s-select-definition label="Cultivo" :def="1173" v-model="filter.TypeCultive" clearable />
                  </v-col>
                  <v-col lg="3" cols="12">
                    <s-select-definition label="Tipo Cultivo" :def="1172" v-model="filter.TypeCrop" clearable />
                  </v-col>
                </v-row>
              </v-container>
            </template>

            <!-- Slot Estado Chip -->
            <template v-slot:HpsStatusText="{ row }">
              <v-chip
                x-small
                :color="row.HpsStatus == 1 ? 'warning' : row.HpsStatus == 2 ? 'success' : 'grey'"
                dark
                class="font-weight-bold"
              >
                {{ row.HpsStatus == 1 ? 'Pendiente' : row.HpsStatus == 2 ? 'Programado' : 'Anulado' }}
              </v-chip>
            </template>
          </s-crud>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-card flat class="pa-3 rounded-lg border-subtle bg-white d-flex align-center justify-space-between">
            <div class="d-flex align-center">
              <v-avatar color="blue lighten-5" size="32" class="mr-2">
                <v-icon small color="primary">mdi-sigma</v-icon>
              </v-avatar>
              <div>
                <span class="subtitle-2 font-weight-bold grey--text text--darken-3">Resumen de Carga: </span>
                <span class="caption grey--text">Total de jabas estimadas registradas</span>
              </div>
            </div>
            <v-chip color="primary" class="font-weight-bold px-3">
              <v-icon left small>mdi-basket</v-icon>
              {{ totalEstimatedJabas }} Jabas
            </v-chip>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import _sHarvestPreSchedule from "@/services/Technicalassistance/HarvestPreScheduleService";
import HarvestPreScheduleEdit from "./HarvestPreScheduleEdit.vue";
import HarvestScheduleEdit from "./HarvestScheduleEdit.vue";

export default {
  name: "HarvestPreSchedule",
  components: {
    HarvestPreScheduleEdit,
    HarvestScheduleEdit,
  },
  data: () => ({
    showEdit: false,
    showArmarSchedule: false,
    item: null,
    itemArmar: null,
    selectedPreCheck: [],
    totalEstimatedJabas: 0,
    filter: {
      HpsBeginDate: null,
      HpsEndDate: null,
      TypeCultive: null,
      TypeCrop: null,
    },
    config: {
      model: {
        accion: "",
        HpsID: "ID",
        HpsDate: "date",
        HpsStatusText: "",
        HpsStatus: "",
      },
      service: _sHarvestPreSchedule,
      headers: [
        { text: "ID", value: "HpsID", width: 60 },
        { text: "Estado", value: "HpsStatusText", width: 110 },
        { text: "Fecha Estimada", value: "HpsDate", width: 120 },
        { text: "Cod.Senasa", value: "FagCodeSenasa", width: 120 },
        { text: "Fundo", value: "FagName", width: 240 },
        { text: "Lote", value: "FltName", width: 90 },
        { text: "Jabas Est.", value: "HpsEstimatedJabas", width: 110 },
        { text: "Productor", value: "PrdText", width: 300 },
        { text: "Cultivo", value: "TypeCultiveText", width: 120 },
        { text: "Variedad", value: "VrtDescription", width: 120 },
        { text: "Tipo Cultivo", value: "TypeCropText", width: 120 },
        { text: "Capataz", value: "FrmName", width: 180 },
        { text: "Observación", value: "HpsObservation", width: 200 },
      ],
    },
  }),
  methods: {
    rowSelected(items) {
      if (Array.isArray(items)) {
        this.selectedPreCheck = items.filter((x) => x && x.HpsStatus == 1);
      } else if (items && items.HpsStatus == 1) {
        this.selectedPreCheck = [items];
      } else {
        this.selectedPreCheck = [];
      }
    },
    getData(item) {
      this.totalEstimatedJabas = 0;
      if (item && item.data) {
        item.data.forEach((x) => {
          this.totalEstimatedJabas += x.HpsEstimatedJabas || 0;
        });
      }
    },
    editItem(item) {
      this.showEdit = true;
      this.item = item;
    },
    closeEdit() {
      this.showEdit = false;
      if (this.$refs.crud) {
        this.$refs.crud.refresh();
      }
    },
    openArmarHarvestSchedule() {
      if (!this.selectedPreCheck || this.selectedPreCheck.length === 0) {
        this.$fun.alert("Seleccione al menos una Pre-Programación", "warning");
        return;
      }
      let firstItem = this.selectedPreCheck[0];
      let totalJabas = this.selectedPreCheck.reduce((sum, x) => sum + (x.HpsEstimatedJabas || 0), 0);
      let hpsIDs = this.selectedPreCheck.map(x => x.HpsID).join(",");

      let itemsForeman = this.selectedPreCheck.map((x, index) => {
        return {
          Line: index + 1,
          FagID: x.FagID,
          HvsID: 0,
          PrdID: x.PrdID,
          PrdText: x.PrdText,
          FltID: x.FltID,
          FltName: x.FltName,
          GenForemanID: x.FrmID || 0,
          Foreman: x.FrmName || "Capataz sin asignar",
          HvsQuantityPerson: 0,
          HvsQuantityMaterial: x.HpsEstimatedJabas || 0,
          DetailsMaterial: [],
          DetailsHarvesters: [],
          Observation: x.HpsObservation || "",
          UsrCreateID: this.$fun.getUserID(),
          UsrUpdateID: this.$fun.getUserID(),
        };
      });

      this.itemArmar = {
        HvsID: 0,
        HvsDate: new Date().toISOString().substring(0, 10),
        HvsQuantity: totalJabas,
        FltID: firstItem.FltID,
        FagID: firstItem.FagID,
        PrdID: firstItem.PrdID,
        TypeCultive: firstItem.TypeCultive,
        TypeCrop: firstItem.TypeCrop,
        VrtID: firstItem.VrtID,
        FltName: firstItem.FltName,
        FagName: firstItem.FagName,
        PrdText: firstItem.PrdText,
        TypeCultiveText: firstItem.TypeCultiveText,
        TypeCropText: firstItem.TypeCropText,
        VrtDescription: firstItem.VrtDescription,
        FagCodeSenasa: firstItem.FagCodeSenasa,
        HpsIDs: hpsIDs,
        Observation: "Consolidado de Pre-Programaciones #" + hpsIDs,
        DetailsGenForeman: itemsForeman,
        itemsForeman: itemsForeman,
      };

      this.showArmarSchedule = true;
    },
    closeArmarSchedule() {
      this.showArmarSchedule = false;
      this.selectedPreCheck = [];
      if (this.$refs.crud) {
        this.$refs.crud.refresh();
      }
    },
  },
};
</script>

<style scoped>
.modal-header {
  background-color: #1565C0 !important;
}
.border-subtle {
  border: 1px solid #E0E0E0 !important;
}
.bg-light {
  background-color: #F8F9FA !important;
}
.lh-1 {
  line-height: 1.2;
}
.opacity-80 {
  opacity: 0.85;
}
</style>
